import { useState, useCallback } from 'react';

interface UseLoadingState {
  isLoading: boolean;
  error: Error | null;
  startLoading: () => void;
  stopLoading: (error?: Error) => void;
  reset: () => void;
}

export function useLoadingState(): UseLoadingState {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const startLoading = useCallback(() => {
    setIsLoading(true);
    setError(null);
  }, []);

  const stopLoading = useCallback((error?: Error) => {
    setIsLoading(false);
    if (error) {
      setError(error);
      console.error('Operation failed:', error);
    }
  }, []);

  const reset = useCallback(() => {
    setIsLoading(false);
    setError(null);
  }, []);

  return {
    isLoading,
    error,
    startLoading,
    stopLoading,
    reset
  };
}